// extracted by mini-css-extract-plugin
export default {"wrapper":"A3-z","message":"B3-z","image":"C3-z"};